/**
 * @generated SignedSource<<b76e199ce27352091cb6911b19211061>>
 * @relayHash 9fe1f2332a20b8576ddcd4fbe09dd8d7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4e0621016f11d02035146dbab036c03b6797f5a69d4e5f2c1b70d5a1eded6857

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { timelineSectionTrialStartDateTrialAwarenessModalQuery } from './timelineSectionTrialStartDateTrialAwarenessModalQuery.graphql';

const node: PreloadableConcreteRequest<timelineSectionTrialStartDateTrialAwarenessModalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "4e0621016f11d02035146dbab036c03b6797f5a69d4e5f2c1b70d5a1eded6857",
    "metadata": {},
    "name": "timelineSectionTrialStartDateTrialAwarenessModalQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
